import React, { useState } from 'react';
import useInterval from '../hooks/use-interval';
import { Flex } from './index';

import './loading.css';

// Waits delay before showing loading
export const Loading = ({ delay = 2000 }: { delay?: number }) => {
  const [visible, setVisible] = useState(false);

  useInterval(() => {
    setVisible(true);
  }, delay);

  if (!visible) return null;

  return (
    <Flex
      sx={{
        height: '100vh',
        width: '100vw',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div className="loading-spinner">Loading...</div>
    </Flex>
  );
};
